// Project Tracker: the Rules page helpers (Step 4 of Section 30).
// No imports here, so it can be tested on its own.

export const RULES_MAX = 150000; // characters
const KEEP_IN_EXPORT = 5; // latest History lines carried in the Export

// Warns only when text looks like a real secret VALUE (for example "password: abc123xyz").
// The plain words (secret, passw, token ...) are allowed here, because Rule 6 itself names them.
const REAL_SECRET = /(secret|passw\w*|token|private_key|api_?key)\s*[:=]\s*\S{6,}|AIza[0-9A-Za-z_-]{20,}|-----BEGIN [A-Z ]*PRIVATE KEY/i;

export function looksLikeRealSecret(text) {
  return typeof text === "string" && REAL_SECRET.test(text);
}

// The dated History line for a change, or null when nothing changed.
export function describeChange(oldText, newText) {
  const a = typeof oldText === "string" ? oldText : "";
  const b = typeof newText === "string" ? newText : "";
  if (a === b) return null;
  if (!a) return "Rules created (" + b.length + " characters)";
  return "Rules changed (" + a.length + " → " + b.length + " characters)";
}

function isoOf(u) {
  if (u && typeof u.toDate === "function") return u.toDate().toISOString();
  return typeof u === "string" ? u : "";
}

// Puts the Rules in front of the tasks in the Export file.
export function withRules(file, rules) {
  const r = rules || {};
  const lockAndSummary = {};
  if (file.onlyProject) lockAndSummary.onlyProject = file.onlyProject;
  if (file.onlyProjects) lockAndSummary.onlyProjects = file.onlyProjects;
  if (file.summary) lockAndSummary.summary = file.summary;
  if (file.summaryTable) lockAndSummary.summaryTable = file.summaryTable;
  return {
    format: file.format,
    version: file.version,
    exportedAt: file.exportedAt,
    about: file.about,
    ...lockAndSummary,
    rules: {
      about: "The Owner's rules for Claude (Start Here, How changes are made, Projects). Read them first. Do not change them in a session file; the import ignores this part.",
      updatedAt: isoOf(r.updatedAt),
      text: typeof r.text === "string" ? r.text : "",
      history: (Array.isArray(r.history) ? r.history : []).slice(-KEEP_IN_EXPORT),
    },
    tasks: file.tasks,
    ...(file.doneTasks ? { doneTasks: file.doneTasks } : {}),
  };
}
